import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Logo, Wordmark } from './common';
import './AuthShell.css';

// Shelf illustration for the brand panel: bins marked with the pick highlighter
const SHELF_BINS = Array.from({ length: 12 }, (_, i) => i);
const PICKED_BINS = { 1: 3, 6: 2, 8: 1 };

// Layout shared by Sign in, Create account and Join: brand panel on the left, form on the right
export function AuthShell({ title, subtitle, children }) {
  return (
    <div className="login-page">
      <aside className="login-brand" aria-hidden="true">
        <div className="login-brand-logo">
          <Logo size={32} onDark />
          <Wordmark />
        </div>

        <div className="login-shelf">
          {SHELF_BINS.map(bin => (
            <div key={bin} className={`login-bin ${PICKED_BINS[bin] ? 'picked' : ''}`}>
              {PICKED_BINS[bin] && <span className="login-bin-qty">×{PICKED_BINS[bin]}</span>}
            </div>
          ))}
        </div>

        <div>
          <h2 className="login-brand-title">Find it. Pick it. Ship it.</h2>
          <p className="login-brand-text">
            Every order shows up on a photo of your shelves, with the bins to pick from marked
            and the quantity on top.
          </p>
        </div>
      </aside>

      <main className="login-main">
        <div className="login-card">
          <div className="login-mobile-logo">
            <Logo size={40} />
          </div>
          <h1 className="login-title">{title}</h1>
          {subtitle && <p className="login-subtitle">{subtitle}</p>}
          {children}
        </div>
      </main>
    </div>
  );
}

// Password field with a show/hide button
export function PasswordInput({ id, value, onChange, autoComplete, placeholder, minLength }) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="login-password">
      <input
        id={id}
        type={visible ? 'text' : 'password'}
        className="input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete={autoComplete}
        minLength={minLength}
        required
      />
      <button
        type="button"
        className="login-password-toggle"
        onClick={() => setVisible(show => !show)}
        aria-label={visible ? 'Hide password' : 'Show password'}
      >
        {visible ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
}
